/** The visitor's explicit choice. `auto` (or no cookie) follows the system preference. */
export type ColorThemePreference = 'light' | 'dark' | 'auto';

export const COLOR_THEME_PREFERENCES: ColorThemePreference[] = ['auto', 'light', 'dark'];

export type ColorTheme = 'light' | 'dark';

/** Cookie holding the visitor's explicit choice (`light` | `dark` | `auto`). */
export const COOKIE_COLOR_THEME = 'color-theme';

/**
 * Cookie holding the system preference (`light` | `dark`), kept up to date by
 * public/color-theme-sync.js (loaded by BaseLayout) so the server can resolve `auto`.
 */
export const COOKIE_SYSTEM_COLOR_THEME = 'system-color-theme';

/** Persists the visitor's choice (client-side) so the server can resolve it on the next render. */
export function setColorThemePreferenceCookie(preference: ColorThemePreference): void {
    document.cookie = `${COOKIE_COLOR_THEME}=${preference};path=/;max-age=31536000;SameSite=Lax`;
}

export function parseColorThemePreference(value: string | undefined): ColorThemePreference {
    return value === 'light' || value === 'dark' ? value : 'auto';
}

export function resolveColorTheme(
    preference: ColorThemePreference,
    systemColorTheme: string | undefined,
    isDarkStyleConfigured: boolean
): ColorTheme {
    if (!isDarkStyleConfigured) {
        return 'light';
    }
    if (preference === 'auto') {
        return systemColorTheme === 'dark' ? 'dark' : 'light';
    }
    return preference;
}
